import React from "react";
import { CircularProgress, withStyles } from "@material-ui/core";
import ImageList from "./ImageList";
import { PRO_IMAGES } from "./getBlobImages";
import capitalize from "lodash/capitalize";

const proImagesTabStyle = (theme) => ({
  container: {
    color: theme.gridTextColor,
    textTransform: "capitalize",
    margin: "12px 0",
  },
});

const ProImagesTabPanel = withStyles(proImagesTabStyle)(
  ({ proImages, imageURLDetailsByTimestamp, classes }) => {
    if (!Object.keys(proImages).length) {
      return <ImageList images={[]} label={""} />;
    }

    return (
      <>
        {Object.keys(proImages).map((proImageKey) => {
          const label = capitalize(
            `${PRO_IMAGES[proImageKey] || proImageKey} Images`
          );
          return (
            <div key={proImageKey}>
              <div className={classes.container}>{label}</div>
              <ImageList
                images={proImages[proImageKey] ?? []}
                label={label}
                imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
              />
            </div>
          );
        })}
      </>
    );
  }
);

const StopImagesTabPanel = ({
  stopImages = [],
  label,
  imageURLDetailsByTimestamp,
}) => {
  return (
    <ImageList
      images={stopImages}
      label={label}
      imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
    />
  );
};

const LoadingView = ({ label = "Loading", labelClass = {} }) => {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress color={"primary"} size={32} />
      <div className={labelClass}>{label}</div>
    </div>
  );
};

export { ProImagesTabPanel, StopImagesTabPanel, LoadingView };
